import { State } from './types';

const mutations = {
  setUserGroupToken(state: State, token: string) {
    state.userGroupToken = token;
  },
  setLoadingState(state: State, loading: boolean) {
    state.loading = loading;
  },
  setExploError(state: State, error: boolean) {
    state.exploError = error;
  }
};
export default mutations;
